import { styled } from "../stitches.config";
import { NAVIGATION_HEIGHT } from "../../constants/global";
import { Button } from "../_app.style";
import { InfoCircleFill } from "react-bootstrap-icons";
import React from "react";


const PADDING_VALUE = '1rem';

export const ContentArea = styled ('main', {
    display: 'flex',
    flexDirection: 'column',
    gridColumn: '2', // new
    gap: '1rem',
    flex: 1,
    height: '100%',
    minHeight: 0,
    overflowY: 'auto', // 🔑 single scroll container

    '@media (max-width: 900px)': {
      gridColumn: '1 / -1',
    },




})


export const DetailContentArea = styled ('main', {
  // display: 'grid',
  gridTemplateRows: 'auto 1fr auto',
  // gap: '1rem',
  flex: 1,
  gridTemplateAreas: `
      "header"
      "main"
      "footer"
  `,
  height: '100%',

  boxShadow: '0 6px 24px rgba(0,0,0,0.04)',
  background: '#f0f2f5',

  minHeight: 0,
  overflowY: 'auto',
  overscrollBehavior: 'none',

  // variants: {
  //   search: {
  //     true: {
  //       borderRadius: 16,
  //       gridColumn: '1',
  //       width: '75%',
        
  //       justifySelf: 'end', 
  //     },

  //     false: {
  //       // justifySelf: 'center', 
  //       // gridColumn: '1',
  //       // width: '80%',

  //       borderRadius: 16,
  //       gridColumn: '1',
  //       width: '75%',
        
  //       justifySelf: 'end', 


  //     },

  //   }
  // },

  // defaultVariants: {
  //   search: 'true',
  // },


  // overflowY: 'auto',




})



export const GapCover = styled ('div', {
    position: 'fixed',
    background: '#f0f2f5',
    zIndex: 2,
    left: 0,           //  <-- Also add left and right
    right: `calc(20% - 0.5rem)`,   
    // right: 0,   
    top: 0,
    height: '12rem',

    '@media (max-width: 900px)': {
      right: 0,
    },

    variants: {
      detail: {
        true: {
          height: '8rem',
        }
      }
    }
    // bottom: `calc(100vh - (${NAVIGATION_HEIGHT} + ${PADDING_VALUE} + 8rem))`,
    // bottom: `calc(100vh - (${NAVIGATION_HEIGHT} + ${PADDING_VALUE} + 1rem))`

    // variants: {
    //   detailedView: {
    //     true: {
    //       bottom: `calc(100vh - (${NAVIGATION_HEIGHT} + ${PADDING_VALUE} + 1rem))`,
    //     },
    //     false: {
    //       bottom: `calc(100vh - (${NAVIGATION_HEIGHT} + ${PADDING_VALUE} + 8rem))`,
    //     }
    //   }

    // },

})

export const BottomGapCover = styled ('div', {
    position: 'fixed',
    background: '#f0f2f5',
    zIndex: 2,
    left: 0,           
    right: `calc(20% - 0.5rem)`,      
    height: '3rem',
    bottom: 0,

    '@media (max-width: 900px)': {
      right: 0,
    }
})

export const SearchArea = styled('div', {
    position: 'sticky',
    top: PADDING_VALUE,
    zIndex: 3,
})


export const PageSelectArea = styled('div', {
    position: 'sticky',
    zIndex: 3,
    paddingTop: '2rem',
    bottom: '1rem',
    marginTop: 'auto',
})

export const SearchPageShell = styled('div', {
  background: '#f0f2f5',
  display: 'grid', 
  boxSizing: 'border-box',
  gridTemplateColumns: '1fr 60% 1fr',
  gap: '1rem',  
  minHeight: '100dvh',
  padding: `calc(${NAVIGATION_HEIGHT} + 1rem) 1rem 1rem`,
});

export const SearchPageShell2 = styled('div', {
  background: 'transparent',
  display: 'grid', 
  boxSizing: 'border-box',
  gridTemplateColumns: '20% 80%',
  gap: '1rem',
  height: '100%',
  minHeight: 0,     
  overflow: 'hidden', 
  padding: `0rem 1rem 1rem`,
  position: 'relative', 

  '@media (max-width: 900px)': {
    gridTemplateColumns: '100%', 
    padding: '0rem 1rem 1rem',
  }
});

export const InfoCircleMod = styled(InfoCircleFill, {
  size: 13,
  marginRight: '0.5rem', 
  fill: '$blue7',
});

export const InfoBanner = styled('div', {
  display: 'flex',
  justifyContent: 'space-between', // Pushes children to opposite ends
  alignItems: 'center',         // Vertically centers the children
  width: '100%',
  margin: '0 auto',
  padding: '1rem 1.5rem',
  background: '$blueWeeks',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
});


export const InfoBanner2 = styled('div', {
  width: '75%',
  marginLeft: '0',
  padding: '1rem 1.5rem',
  background: '$blueWeeks',

  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',

  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',

  '@media (max-width: 900px)': {
    width: '100%',
  }

});

export const SidebarWrapper2 = styled('aside', {
  // --- CORE CHANGES ---
  position: 'absolute',    // CHANGE: This is the key. It's positioned relative to DisplayArea.
  right: '1rem',                // ADD: Stick to the right edge of the container.
  width: 'calc(25% - 2rem)',     // subtract the 2rem we’re adding as outside gaps
  top: `calc(${NAVIGATION_HEIGHT} + 1rem)`, // Stick to the top, below the nav
  alignSelf: 'start',
  background: 'white',
  borderRadius: '16px',
  minHeight: '20rem',
  maxHeight: '30rem',
  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
  border: '1px solid $gray6',
  padding: '1.5rem',
  overflow: 'hidden',
  gap: '1rem',
  zIndex: 4,

  
  // The transition for appearing/disappearing
  transition: 'opacity 0.2s ease, transform 0.2s ease, top 0.1s linear',
  opacity: 0,
  transform: 'translateY(10px)',

  '&[data-state="open"]': {
    opacity: 1,
    transform: 'translateY(0)',
  },

  '&[data-state="overflowing"]': {
    opacity: 0,
    transform: 'translateY(10px)',
    visibility: 'hidden',
  },

  '@media (max-width: 900px)': {
  display: 'none !important',
},
});



export const ProfileInitial = styled('div', {
  aspectRatio: '1 / 1',
  border: '3px solid $gray3',
  borderRadius: '50%',
  flexShrink: 0,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  fontWeight: '600',
  textTransform: 'uppercase',

  variants: {

  view: {
    detail: {
       width: '90px',
       fontSize: '2.25rem', // A fixed rem value works well for consistent card sizes
    },
    card: {
      width: '45%', // Use percentage for the larger, responsive view
      maxWidth: '17rem',
      fontSize: 'clamp(1.5rem, 10vw, 6rem)', 
    }
  }
}, 
defaultVariants: {
  view: 'card'
}
});


export const DetailSidebarWrapper = styled('aside', {
  gridColumn: '2',
  top: '4.5rem', // Stick to the top, below the nav
  width: `calc(100% - 1rem)`,
  position: 'sticky',
  minHeight: '20rem',
  maxHeight: '30rem',
  overflow: 'auto',
  alignSelf: 'start',
  

  zIndex: 10,
  background: 'white',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
  border: '1px solid $gray6',
  padding: '1.5rem',
  // borderRight: '1rem',

  // display: 'flex',
  // flexDirection: 'column',
  gap: '1rem',
  right: '1rem',

  '&[data-state="open"]': {
    opacity: 1,
    transform: 'translateY(0)',
    visibility: 'visible',
  },


  '&[data-state="closed"]': {
    opacity: 0,
    transform: 'translateY(10px)',
    visibility: 'hidden',
  },

  '&[data-state="overflowing"]': {
    opacity: 0,
    transform: 'translateY(10px)',
    visibility: 'hidden',
  }


});




// 2. A new container for the text
export const BannerContent = styled('div', {
  display: 'flex',
  flexDirection: 'column', // Stack the text vertically


  justifyContent: 'flex-start', // ✨ ADD THIS: To push the button to the right
});

// 3. The main text style
export const BannerText = styled('p', {
  margin: 0,
  fontWeight: 500,
  color: '$gray12',
  fontSize: '$md',
});

// 4. The subtext style
export const BannerSubtext = styled('p', {
  margin: '0.25rem 0 0 0',
  fontSize: '$sm',
  color: '$gray11',

  a: {
    color: '$blue11',
    fontWeight: '600',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    }
  }

});

// 5. The button (previously BannerIconButton)
export const BannerIconButton = styled('button', { // changed to button for semantics
  all: 'unset', // Important to reset default button styles
  display: 'grid',
  placeItems: 'center',
  cursor: 'pointer',
  width: '2.25rem',
  height: '2.25rem',
  borderRadius: '50%',
  flexShrink: 0,
  marginLeft: '1rem', // Add some space between text and button
  color: '$sand11', // A neutral grey for the icon
  transition: 'background-color 0.2s ease, color 0.2s ease',
    // --- 2. Remove the color change from the hover state ---
    '&:not([data-active="true"]):hover': {
      backgroundColor: '$blueHover',
      // The 'color' property is removed, so it stays black
'& svg': {
      fill: 'var(--colors-blue11)',
    },  
    },
});

export const SearchBarWrapper = styled('div', {
    position: 'relative', // Crucial for positioning the ghost text inside
    width: '100%',
    margin: '0 auto',
    
    // Move the shadow and border-radius here from the input
    borderRadius: '9999px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    border: '1px solid $gray7',
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
    alignItems: 'center', // ✨ ADD THIS: To center the button vertically
  display: 'flex', // ✨ ADD THIS: To enable flexbox
  justifyContent: 'flex-end', // ✨ ADD THIS: To push the button to the right
  
    '&:hover': {
      borderColor: '$gray8',
    },
    // Apply the focus ring to the wrapper when the input inside is focused
    '&:focus-within': {
      borderColor: '$blue9',
      boxShadow: `0 0 0 3px $colors$blueA5, 0 4px 12px rgba(0,0,0,0.05)`,
    },
  });


  export const GhostText = styled('div', {
    position: 'absolute',
    top: '0',
    left: '0',
    padding: '1rem 1.5rem', // Match the input's padding
    fontSize: '$md',
    color: '$gray8',
    // background: 'white',
    pointerEvents: 'none', // Allows clicks to pass through to the input
    whiteSpace: 'pre',
  });
  
  // The input itself now has a transparent background
  export const SearchBarInput = styled('input', {
    width: '100%',
    background: 'transparent', // <-- Key change!
    border: 'none',
    outline: 'none',
    padding: '1rem 1.5rem',
    fontSize: '$md',
    color: '$gray12',

    '&::-webkit-search-cancel-button': {
        '-webkit-appearance': 'none',
        display: 'none'
    },
  });


  export const TagWrap = styled('div', {
    display: 'flex',
    // flexDirection: 'column',
    // justifyItems: 'center',
    flexWrap: 'wrap',
    gap: '0.5rem',
    variants: {
      display: {
        true: {
          margin: '1rem 0 0 0', // Removes the horizontal 'auto' centering
          width: '75%',
        }, 
        false: {
          margin: '1rem auto 0 auto',
          width: '100%',
        }
      },
      detailedView: {
        true: {

          justifyContent: 'center',
          // when wrapping creates multiple rows, this centers the block vertically too
          alignContent: 'center',
        
          width: '100%',

        },
        false: {
          justifyItems: 'flex-start',

        }
      }
      
      },
      defaultVariants: {
        display: 'false',
        detailedView: 'false',
    }

  });

// // Container for the tag "bubbles"
// export const TagWrap = styled('div', {
//   display: 'flex',
//   flexWrap: 'wrap',
//   gap: '0.5rem',

//   // center the chips across the row(s)
//   justifyContent: 'center',
//   // when wrapping creates multiple rows, this centers the block vertically too
//   alignContent: 'center',

//   width: '100%',
//     variants: {
//       display: {
//         true: {
//           margin: '1rem 0 0 0', // Removes the horizontal 'auto' centering
//           width: '75%',
//         }, 
//         false: {
//           margin: '1rem auto 0 auto',
//           width: '100%',
//         }
//       },
      
//       },
//       defaultVariants: {
//         display: 'false',
//     }

//   });
  
  export const Tag = styled('div', {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',

    fontWeight: 500,
    padding: '0.25rem 0.75rem',
    borderRadius: '9999px',
    fontSize: '$sm',
    background: '$blue3',
    color: '$blue11',

    variants: {
      isMatch: {
        true: {
          background: '$green3',
          color: '$green11',
        },
        false: {
          background: '$blue3',
          color: '$blue11',
        }
      }
    },
    defaultVariant: { 
      isMatch: 'false',
    }
  });
  
  // The 'x' button to remove a tag
  export const RemoveTagButton = styled('button', {
    all: 'unset',
    display: 'grid',
    placeItems: 'center',
    width: '1rem',
    height: '1rem',
    borderRadius: '50%',
    cursor: 'pointer',
    color: '$blue9',
    transition: 'background-color 0.2s ease',
  
    '&:hover': {
      backgroundColor: '$blueA4',
      color: '$blue11',
    },
  });
  


  export const FilterButton = styled('button', {
    all: 'unset',
    display: 'inline-flex', // Use inline-flex to align icon and text
    alignItems: 'center',
    gap: '0.5rem', // Space between icon and text
    cursor: 'pointer',
    padding: '0.5rem 1rem',
    borderRadius: '8px',
    color: '$gray11',
    fontWeight: 500,
    flexShrink: 0,
    marginLeft: '1rem',
    transition: 'background-color 0.2s ease, color 0.2s ease',
    
    '&:hover': {
      backgroundColor: '$grayA3',
      color: '$gray12',
    },
  });





// --- The main area for tutor cards ---
export const ResultsGrid = styled('div', {
    display: 'grid',
    gap: '1.5rem',
    margin: '1.5rem auto 0 auto', // Add margin top to space from elements above
  });
  
  export const ResultsGrid2 = styled('div', {
    display: 'grid',
    gap: '1.5rem',
    // width: '100%',
    marginLeft: 0, 
    marginTop: '1.5rem',
    width: '75%',

    '@media (max-width: 900px)': {
      width: '100%',
    }
    // margin: '1.5rem auto 0 auto', // Add margin top to space from elements above
  });

  export const ResultsGrid3 = styled('div', {
    display: 'grid',
    gap: '1.5rem',
    justifySelf: 'center',
    width: 'min(75%, 1200px)', // keeps it from getting too wide on big screens
    marginInline: 'auto',   // <— center the 75% block in all browsers
  })

  // --- A placeholder for individual tutor cards ---
  export const TutorCardPlaceholder = styled('div', {
    height: '350px',
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0 6px 24px rgba(0,0,0,0.06)',
    border: '1px solid $gray6',
    display: 'grid',
    placeItems: 'center',
    color: '$gray9',
    fontSize: '$sm',

    '&hover ' : {

    },
  });


  // In src/styles/search/search.style.ts

export const NoResultsMessage = styled('div', {
  position: 'absolute',
  width: '100%',
  inset: 0, // Covers the entire parent
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: '$lowContrast',

  '> h2': {
    margin: 0,
    marginBottom: '0.5rem',
  },
});

// In src/styles/search/search.style.ts

export const LoadingOverlay = styled('div', {
  position: 'absolute',
  width: '100%',
  inset: 0, // Covers the entire parent
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // backgroundColor: 'rgba(255, 255, 255, 0.7)',
  zIndex: 10,
  background: '#f0f2f5',
  // borderRadius: '16px', // Match DisplayArea's border radius if it has one
});


export const LoadingTopLayer = styled('div', {
  position: 'absolute',
  width: '75%',
  inset: 0, // Covers the entire parent
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10,


})

export const TutorCardWrapper = styled('div', {
  position: 'relative', // ✅ This is the crucial line to add
    background: 'white',
    overflow: 'hidden',
    borderRadius: '16px',
    boxShadow: '0 6px 24px rgba(0,0,0,0.06)', // Matched to placeholder
    border: '1px solid $gray6',               // Matched to placeholder
    minHeight: '20rem',                           // Matched to placeholder for uniform grid
    
    padding: '1.5rem',
    // display: 'flex',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
    // textAlign: 'center',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',

    '&:hover': {
      transform: 'translateY(-4px)',
    //   boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    boxShadow: '0 12px 35px rgba(40, 167, 69, 0.2)',

    }
  });
  
  export const TutorImage = styled('img', {
    // maxWidth: '17rem',   // <-- Changed to rem
    // maxHeight: '17rem',  // <-- Changed to rem
    width: '45%', 
    maxWidth: '17rem',



    // flex: '0 1 17rem', 
    aspectRatio: '1/1',

  //   flexShrink: 0, // ✅ Add: Prevents the image from being squished
  // flexBasis: '15rem', // ✅ Change: Sets the ideal starting size
  // aspectRatio: '1 / 1', // ✅ Add: Keeps the image a perfect square
  // maxWidth: '40%',    // ✅ Add: Ensures it's never more than 40% of the card

    borderRadius: '50%',
    objectFit: 'cover',
    // marginBottom: '1rem',
    border: '3px solid $gray3',
  });

  export const TutorName = styled('h3', {
    margin: '0 0 0.25rem 0',
    fontSize: '$lg',
    fontWeight: 600,
    color: '$gray12',
  });
  
  // NEW: A component for the credentials line
  export const TutorCredentials = styled('p', {
    margin: '0',
    fontSize: '$md',
    color: '$gray10', // Slightly lighter to be secondary
    fontWeight: 500,
  });
  
  // MODIFIED: This is now for the main description text
  export const TutorDescription = styled('p', {
    margin: '0.75rem 0 0 0',
    fontSize: '$sm',
    color: '$gray11',
    lineHeight: 1.5,

    overflowWrap: 'break-word',
    wordBreak: 'break-word', 
  
    // This is a modern CSS trick to truncate text after 3 lines
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  });
  

export const TutorInfo = styled('div', {
    display: 'flex',
    flexDirection: 'column',

    textAlign: 'left', // Align text to the left
    flexGrow: 1,       // Allow it to take up the remaining space
    variants: {
      isDetailedView: {
        true: {
          alignItems:'center',
          textAlign: 'center',
        },
        false: {
// nada 
        },
      }

    },
    defaultVariants: {
      isDetailedView: 'false',
    },
    '@media (max-width: 1000px)': {
      // paddingTop: '1.5rem',
    }

  });


  // In your styles/search/search.style.ts file

export const TutorDetailWrapper = styled('div', {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  width: '75%',
  background: '$appBackground', 
  zIndex: 100,
  overflowY: 'auto',
  padding: '1.5rem',
});

// This is the grid that lays out the cards inside the detail view
export const TutorDetailGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: '350px 1fr', // A column for the photo and a flexible one for info
  gridTemplateRows: 'auto 1fr',   // A row for the bio, and a flexible one for other cards
  gap: '1.5rem',
  height: '100%',
  gridTemplateAreas: `
    "photo bio"
    "photo info"
  `,
});

// We can reuse the CardBase style from your profile page for consistency
const CardBase = {
  background: 'white',
  borderRadius: 16,
  boxShadow: '0 6px 24px rgba(0,0,0,0.04)',
  display: 'flex',
  flexDirection: 'column',
};

// Define the new card components and assign them to grid areas
export const TutorPhotoCard = styled('div', {
  ...CardBase,
  gridArea: 'photo',
  padding: 0, // No padding for the image card
});

export const TutorBioCard = styled('div', {
  ...CardBase,
  gridArea: 'bio',
});

export const TutorInfoCard = styled('div', {
  ...CardBase,
  gridArea: 'info',
});

// You should already have these from your profile page styles


// MODIFIED: The sidebar is now a sticky element in the right-hand column.
export const SidebarWrapper = styled('aside', {
  gridColumn: '3', // Place this in the right-hand column (the gutter)

  position: 'sticky',
  top: `calc(${NAVIGATION_HEIGHT} + 1rem)`, // Stick to the top, below the nav
  alignSelf: 'start', // Prevents the sidebar from stretching vertically

  background: 'white',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
  border: '1px solid $gray6',
  padding: '1.5rem',
  zIndex: 50,
  
  transition: 'opacity 0.2s ease, transform 0.2s ease',
  opacity: 0,
  transform: 'translateX(10px)',

  '&[data-state="open"]': {
    opacity: 1,
    transform: 'translateX(0)',
  },
});




export const MetricGroup = styled('div', {
  marginBottom: '1.5rem',
});

export const MetricLabel = styled('h4', {
  margin: '0 0 0.5rem 0',
  fontSize: '$md',
  fontWeight: 600,
  color: '$gray12',
});

export const MetricScore = styled('p', {
  margin: 0,
  fontSize: '1.5rem',
  fontWeight: 'bold',
  color: '$blue11',
  lineHeight: 1,
});

export const MetricDescription = styled('p', {
  margin: '0.25rem 0 0 0',
  fontSize: '$sm',
  color: '$gray11',
});


// attempt to make the detailed card view similar 

export const TutorDetailCard = styled('div', {
  borderRadius: 16,

  boxShadow: '0 6px 24px rgba(0,0,0,0.04)',
  background: '#f0f2f5',


});


export const TutorDetailCard2 = styled('div', {
  variants: {
    search: {
      true: {
        borderRadius: 16,
        gridColumn: '1',
        width: '75%',
        overflowY: 'auto',
        
        justifySelf: 'end', 
        boxShadow: '0 6px 24px rgba(0,0,0,0.04)',
        background: '#f0f2f5',
      },

      false: {
        justifySelf: 'center', 
        boxShadow: '0 6px 24px rgba(0,0,0,0.04)',
        background: '#f0f2f5',
      },

    }
  },

  defaultVariants: {
    search: 'true',
  },

});

export const TutorDetailCard3 = styled('div', {
    borderRadius: 16,
    boxShadow: '0 6px 24px rgba(0,0,0,0.04)',
    background: '#f0f2f5',  
    display: 'flex', 
    flexDirection: 'column',
});

export const CardHeader2 = styled('div', {
  gridRow: 1,
  zIndex: 3,
  padding: '0 1.5rem',            // Horizontal padding for the title
  position: 'sticky',
  top: '1rem',
  height: '3.5rem',               // "a couple of rem long"
  alignItems: 'center', // ✨ ADD THIS: To center the button vertically
  display: 'flex', // ✨ ADD THIS: To enable flexbox
  justifyContent: 'space-between', // ✨ ADD THIS: To push the button to the right
  borderBottom: '1px solid $elementBorder', // Separator line
  background: '$blueWeeks',
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  fontSize: '$md',
  fontWeight: 600,
  color: '$sand12',
});

export const DetailCardHeader = styled('div', {
  // gridArea: 'header',
  // zIndex: 3,
  padding: '0 1.5rem',            // Horizontal padding for the title
  // position: 'sticky',
  // top: '1rem',
  flexShrink: 0,
  height: '3.5rem',               // "a couple of rem long"
  alignItems: 'center', // ✨ ADD THIS: To center the button vertically
  display: 'flex', // ✨ ADD THIS: To enable flexbox
  justifyContent: 'space-between', // ✨ ADD THIS: To push the button to the right
  borderBottom: '1px solid $elementBorder', // Separator line
  background: '$blueWeeks',
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  fontSize: '$md',
  fontWeight: 600,
  color: '$sand12',
});

export const CardHeader3 = styled('div', {
  padding: '0 1.5rem',            // Horizontal padding for the title
  // position: 'sticky',
  // top: 0,

  height: '3.5rem',               // "a couple of rem long"
  alignItems: 'center', // ✨ ADD THIS: To center the button vertically
  display: 'flex', // ✨ ADD THIS: To enable flexbox
  flexShrink: 0, 
  justifyContent: 'space-between', // ✨ ADD THIS: To push the button to the right
  borderBottom: '1px solid $elementBorder', // Separator line
  background: '$blueWeeks',
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  fontSize: '$md',
  fontWeight: 600,
  color: '$sand12',
});

export const CardFooter = styled('div', {
  gridRow: 3,
  zIndex: 3,
  display: 'flex',
  position: 'sticky',
  bottom: '1rem',
  justifyContent: 'space-between', // Pushes buttons to opposite ends
  alignItems: 'center',
  height: '3.5rem',               // "a couple of rem long"
  padding: '0 1.5rem', // Match horizontal padding of header
  borderTop: '1px solid $elementBorder', // Separator line
  background: '$blueWeeks',
  // flexShrink: 0,
  borderBottomLeftRadius: 16,
  borderBottomRightRadius: 16,
});


export const DetailFooter = styled('div', {
  // gridArea: 'footer',
  // zIndex: 3,
  display: 'flex',
  // position: 'sticky',
  flexShrink: 0,
  // bottom: '1rem',
  justifyContent: 'space-between', // Pushes buttons to opposite ends
  alignItems: 'center',
  height: '3.5rem',               // "a couple of rem long"
  padding: '0 1.5rem', // Match horizontal padding of header
  borderTop: '1px solid $elementBorder', // Separator line
  background: '$blueWeeks',
  // flexShrink: 0,
  borderBottomLeftRadius: 16,
  borderBottomRightRadius: 16,
});

export const CardFooter2 = styled('div', {
  display: 'flex',
  // position: 'sticky',
  flexShrink: 0,
  // bottom: 0,
  justifyContent: 'space-between', // Pushes buttons to opposite ends
  alignItems: 'center',
  height: '3.5rem',               // "a couple of rem long"
  padding: '0 1.5rem', // Match horizontal padding of header
  borderTop: '1px solid $elementBorder', // Separator line
  background: '$blueWeeks',
  // flexShrink: 0,
  borderBottomLeftRadius: 16,
  borderBottomRightRadius: 16,
});

export const CardContent2 = styled('div', {
  // gridRow: 2,
  padding: '1.5rem', // The padding that used to be on the card itself
  // flex: 1,       // Allows this area to grow and fill available space
  // overflowY: 'auto', // Makes the content area scrollable if needed, not the whole card
  fontSize: '$sm',
  flexDirection: 'column',     
  // position: 'relative',
  display: 'flex', 
  minHeight: 0, // Ensure scroll works correctly inside a flexbox
  position: 'relative',
  flexGrow: 1, 
  flexShrink: 1, 
  background: 'white',
  // flex: '1 1 auto', // Allows this element to grow and shrink
  overflowY: 'auto', // ✨ The magic property! Shows scrollbar when needed.
  
});



export const DetailContent = styled('div', {
  padding: '1.5rem',
  fontSize: '$sm',
  flexGrow: 1,
  flexShrink: 1,
  minHeight: 0,
  position: 'relative',
  background: 'white',
  overflowY: 'auto',
  overscrollBehavior: 'none',
});


// In your styles file
export const TutorDetailWrapper2 = styled('div', {
  display: 'flex',          
  flexDirection: 'column',     
  alignItems: 'center',     
  gap: '1.5rem',

  // 👇 The two key changes are here
  width: 'max-content',     // 1. Shrink wrapper to fit the content inside it
  margin: '0 auto',         // 2. Add equal margin to left/right, pushing it to the center
});



export const DisplayArea = styled('div', {
  position: 'relative',
  zIndex: 1,
  flex: 1,
});



export const DetailPageShell = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center', 
  alignItems: 'center', 
  paddingTop: `calc(${NAVIGATION_HEIGHT} + 1rem)`,
  paddingBottom: '1rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  background: '#f0f2f5',
  // minHeight: '100vh',
  boxSizing: 'border-box',
});

export const DetailPageShell2 = styled('div', {
  paddingBottom: '1rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  margin: '0 1rem', 
  background: '#f0f2f5',
  // minHeight: '100%',
  boxSizing: 'border-box',
  // position: 'relative',

  variants: {
    search: {
      true: {
        paddingTop: '1rem',
        // paddingTop: '1rem',
      },

    }
  },

  defaultVariants: {
    search: 'true',
  }
})



export const DetailPageShell3 = styled('div', {
    background: '#f0f2f5',
    display: 'flex', 
    flexDirection: 'column',
    boxSizing: 'border-box',
    // gap: '1rem',
    // height: '50dvh',
    minHeight: 0,     
    overflow: 'hidden', 


    height: '100%', 
    width: '100%',
    
    // ✨ ADD THESE TWO LINES:
    borderRadius: 16,      // Round the outer shell

    // padding: `1rem 1rem 1rem`,
    // position: 'relative', 

    // variants: {
    //   search: {
    //     true: {
    //     gridTemplateColumns: '80% 20%',
    //     columnGap: '1rem',
    //     },
    //     false: {
    //       // COMMAND: Create one single column that spans 100% of the available width.
    //       // gridTemplateColumns: '100%', 
    //       gridTemplateColumns: '80% 20%',
    //       columnGap: '1rem',
    //       // justifyContent: 'center', // This will center the items within the grid cells
    //     },
    //   },
    // },

    // defaultVariants: {
    //   search: 'true',
    // },
  });


/* --- The two-pane white card ----------------------------------------- */
/* --- 1. Wrapper: ONLY the grid ------------------------------------ */
export const DetailPageWrapper = styled('div', {
  // display: 'grid',
  // gridTemplateColumns: '320px 1fr',
  // columnGap: '1rem',          // ← 1-rem “sliver” between panes
  // display: 'grid',
  // gridTemplateColumns: '80% 20%',
  width: '60%',
  alignContent: 'center'
});

export const DetailPageWrapper2 = styled('div', {
  minHeight: 0,

  variants: {
    search: {
      true: {
        display: 'grid',
        gridTemplateColumns: '80% 20%',
        columnGap: '1rem',
        height: '100%',
        minHeight: 0,     
      },

      false: {
        // display: 'grid',
        // justifyContent: 'center',
        // minWidth: '100%'

        display: 'grid',
        // COMMAND: Create one single column that spans 100% of the available width.
        gridTemplateColumns: '100%', 
        justifyContent: 'center', // This will center the items within the grid cells
        width: '100%',
      },

    }
  },

  defaultVariants: {
    search: 'true',
  },



});
// In your styles file (e.g., src/styles/search/search.style.ts)

// A base style for all buttons
export const ButtonBase = styled('button', {
  padding: '0.5rem 1rem',
  border: 'none',
  borderRadius: 8,
  fontSize: '$sm',
  fontWeight: 600,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out',
  display: 'flex',
  alignItems: 'center',      // This vertically centers the icon and text
  justifyContent: 'center', // This horizontally centers them as a group
  gap: '0.5rem',            // This creates the gap between the icon and text
});

// A button for primary actions (e.g., Message)
export const PrimaryButton = styled(ButtonBase, {
  background: '$blue8', // Example primary color
  color: 'white',
  '&:hover': {
    background: '$blue10',
  }
});

// A button for secondary actions
export const SecondaryButton = styled(ButtonBase, {
  background: 'transparent',
  // color: '$sand12',
  '&:hover': {
    // background: '$sand4',
    background: '$blueHover',
  },
  variants: {
    normal: {
    true: {
      border: '1px solid $sand12',

    },
    false: {
      border: 'none'
    }
  },


  },

  defaultVariants: {
    normal: 'true',
  },
});


export const ButtonText = styled('span', {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis', 
  minWidth: 0, 
  flex: 1, 
  textAlign: 'center',
})


// Add these to src/styles/profile/form.style.ts

/* --- Weekly Schedule Grid --- */

/**
 * The main container for the weekly schedule calendar.
 */
export const ScheduleGrid = styled('div', {
  display: 'grid',
  // 1 column for time headers, 7 for days of the week
  gridTemplateColumns: 'max-content repeat(7, 1fr)',
  border: '1px solid $elementBorder',
  borderRadius: '12px',
  overflow: 'hidden', // Clips the corners of the cells inside
  marginTop: '1.5rem',
  backgroundColor: '$elementBorder', // Background will show through as grid lines
  gap: '1px',
});

/**
 * The header cells for the days of the week (e.g., "Monday").
 * Styled to match your existing GridHeader.
 */
export const GridHeaderCell = styled('div', {
  padding: '0.75rem',
  fontWeight: 600,
  fontSize: '$xs',
  textAlign: 'center',
  // Styling matches your existing GridHeader
  backgroundColor: '$blueWeeks',
  color: '$sand12',
});

/**
 * The header cells for the time of day (e.g., "8 AM", "9 AM").
 * Given a slightly different, more neutral style.
 */
export const TimeHeaderCell = styled('div', {
    padding: '0.75rem',
    fontWeight: 500,
    fontSize: '$xs',
    textAlign: 'right',
    color: '$sand11',
    backgroundColor: 'white',
});

/**
 * The main data cell in the schedule, which changes color based on status.
 */
export const ScheduleCell = styled('div', {
  minHeight: '2.5rem',
  backgroundColor: 'white', // Default background for empty cells

  // Variants for the different availability statuses
  variants: {
    status: {
      empty: { 
        backgroundColor: 'white',
      },
      overlap: { // Green
        backgroundColor: '$green4',
        // '&:hover': { backgroundColor: '$green5' } 
      },

      user1Only: {
        backgroundColor: '$yellow3',
      },

      user2Only: {
        backgroundColor: '$blue4',
      },

      'tutor-only': { // Red
        backgroundColor: '$yellow3',
        // '&:hover': { backgroundColor: '$yellow4' }  
      },   
      'parent-only': { // Blue
        backgroundColor: '$blue4',
        // '&:hover': { backgroundColor: '$blue5' } 
      },  
    }
  },
  defaultVariants: {
    status: 'empty'
  }
});


// In src/styles/search/search.style.ts

export const ScheduleKeyContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap', // Allows key to wrap on smaller screens
  gap: '1.5rem',
  padding: '0.5rem 0 1rem 0', // Space above and below the key
});

export const ScheduleKeyItem = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

export const ScheduleKeyColorBox = styled('div', {
  width: '1rem',
  height: '1rem',
  borderRadius: '4px',
  border: '1px solid $neutral7',
  
  // These colors should match the ones in your <ScheduleCell> component
  variants: {
    color: {
      overlap: { backgroundColor: '$green4' },
      tutor: { backgroundColor: '$yellow3' },
      parent: { backgroundColor: '$blue4' },
      user1Only: {backgroundColor: '$yellow3'},
      user2Only: {backgroundColor: '$blue4'},
    }
  }
});

export const ScheduleKeyLabel = styled('span', {
  fontSize: '$sm',
  color: '$neutral11',
});

export const NameAndPriceWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between', // Pushes items to opposite ends
  alignItems: 'center',          // Vertically aligns them
  width: '100%',
  gap: '1rem',
  '@media (max-width: 800px)': { // This breakpoint is a good starting point for cards
    flexDirection: 'column',   // 🥞 Stack them vertically
    alignItems: 'flex-start',  // Align them to the left
    gap: '0.25rem',            // Reduce the gap for a tighter look
    marginBottom: '0.5rem'
  }

    // marginBottom: '0.25rem',

});

export const PriceDisplay = styled('div', {
  fontSize: '$lg',
  fontWeight: 'bold',
  color: '$blue11',
  flexShrink: 0, // Prevents the price from shrinking or wrapping
});

// In src/styles/search/search.style.ts

export const CornerTagContainer = styled('div', {
  position: 'absolute',
  top: '12px',
  right: '12px',
  // zIndex: 2,
  display: 'flex',       // Use flexbox to manage the tags
  flexDirection: 'row', // Stack them vertically
  flexWrap: 'wrap',
  alignItems: 'flex-end',  // Align them to the right
  gapBottom: '3rem',
  gap: '6px',              // Add a small space between tags

});

// In src/styles/search/search.style.ts

export const CornerTag = styled('div', {
  // position: 'absolute',
  // top: '12px',
  // right: '12px',
  padding: '4px 8px',
  borderRadius: '6px',
  fontSize: '$xs',
  fontWeight: 'bold',
  color: 'white',
  // zIndex: 2, // Ensures it sits on top of other card content

  // Add variants for different colors
  variants: {
    color: {
      green: { background: '$green9' },
      blue: { background: '$blue9' },
      yellow: {background: '$yellow7'},
      gray: {background: '$red9'}
    }
  },
  defaultVariants: {
    color: 'green',
  }
});



export const Overlay = styled('div', {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overscrollBehavior: 'none',
});

export const Dialog = styled('div', {
  width: 'min(920px, 96dvw)', maxHeight: '90dvh', overflow: 'auto', background: 'white', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.25)', overscrollBehavior: 'none',
});
